export const HealthStatus = {
    Good: {
        Key: "Good",
        Code: 1
    },
    Warning: {
        Key: "Warning",
        Code: 3
    },
    Error: {
        Key : "Error",
        Code: 2
    },
    Information: {
        Key :"Information",
        Code: 4
    }
}

export const ServiceIncidentStatus = {
    Active: "Active",
    Resolved: "Resolved"
}

export const ServiceHealthPageType = {
    Status: 0,
    Public: 1,
    Admin: 2
}

export const ServiceHealthAdminStrings = {
    Cancel: "Cancel",
    ContactDevTeamAlert: " , please contact dev team if this persists.",
    Hidden: "Hidden:",
    CreateServiceIncidentErrorMissingSummary: "Please add an incident summary if service status is not ‘Good’",
    EditService: "Edit Service",
    HealthLevel: "Health Level",
    HideRadio: "Hide Service health",
    LearnManagePermissions: "Learn how to manage permissions.",
    Mitigation: "Mitigation",
    MsxVisibilityClaim: "MSXServiceHealthStatusListAdmin",
    NoAccountAccessForProductFamilyAlert: "A problem has occurred, your account has not the right access for any product family.",
    PartnerCenterVisiblityClaim: "ServiceHealthStatusListAdmin",
    ProductFamiliesAvailable: "Product families available",
    ProductFamiliesNotFetchedAlert: "A problem has occurred while fetching the product families associated to your account, please contact dev team if this persists.",
    RootCause: "Root cause",
    SelectAProductFamily: "Select a product family",
    ServerErrorAlert: "A problem has occurred, server returned error ",
    ServiceHealthAdmin: "Service health admin",
    ServicesInfoNotAvailable: "Service health info isn’t available right now, try again later!",
    ServiceVisibilityUnauth: "You are not authorized to edit service visiblity. Please ensure you are a member of the ServiceHealthStatusListAdmins (for PC) or MSXServiceHealthStatusListAdmins (for MSX) security group.",
    SetShowHideOption: "Set whether to show or hide the health status for this service area",
    ShowActive: "Show Active",
    ShowAll: "Show all",
    ShowRadio: "Show Service Health",
    SummaryImpact: "Summary of impact",
    UnAuthMessage: "Unauthorized access, please contact service owner.",
    UnauthorizedAccess: "You don’t have permission to view this page. Contact your account admin for access.",
    UpdateService: "Update Service",
    UpdateServiceErrorMessage: "There’s a problem updating the service health info.",
}